// extracted by mini-css-extract-plugin
module.exports = {"TickerPill":"TickerPill_TickerPill__VaWJ6"};